export default "__VITE_ASSET__Bwd1Sov3__"